/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { cardLectures } from "assets/jss/material-kit-pro-react/components/cardStyle.jsx";

export const crsCardStyles = {
  // crsList: for Course List
  //
  crsListCard: {
    display: "grid",
    gridTemplateColumns: "100%",
    gridTemplateRows: `1fr 4fr 1fr`,
    gridTemplateAreas: "'clcHead' 'clcBody' 'clcFooter'",
    "& h2, h6": { fontFamily: "Raleway" },
  },

  crsHead: {
    gridArea: "clcHead",
    color: "#FFFFFF",
    fontWeight: "700",
    padding: "1rem",
  },

  crsFooter: {
    gridArea: "clcFooter",
    backgroundColor: "#25285080",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0 0 8px 8px",
  },

  // crsFound: for Course/Lecture found
  //
  crsFoundCard: {
    ...cardLectures,
    backgroundSize: "cover",
    width: "95%",
    margin: "0.75rem auto",
    padding: 0,
    borderRadius: "8px",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 8px 4px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    position: "relative",
  },

  crsFoundCardHead: {
    display: "flex",
    "@media (min-width: 768px)": {
      flexDirection: "row",
    },
    flexDirection: "column",
    alignItems: "center",
    textAlign: "left",
    backgroundColor: "#00000020",
    width: "100%",
    minHeight: "6rem",
    borderRadius: "8px 8px 0 0",
    top: 0,
    padding: "0.75rem 0 0 1rem",
  },

  crsTitle: {
    "@media (min-width: 768px) ": {
      width: "65%",
    },
    width: "100%",
  },

  crsFoundCardBody: {
    "@media (min-width: 768px) ": {
      margin: "0 6rem",
      padding: "1rem 2rem",
    },
    margin: "0 1rem",
    padding: "1rem 0",
    backgroundColor: "#25285080",
  },
};
